import { render, staticRenderFns } from "./IpoDemandForecast.vue?vue&type=template&id=fe2a560a"
import script from "./IpoDemandForecast.vue?vue&type=script&lang=js"
export * from "./IpoDemandForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports